import { Component, OnInit, ViewChild } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { SeFeDomainEnvironmentService } from 'se-fe-domain-environment'

import { AnalyticsService, AuthSessionService, InviteService, UserServiceCsrfTokenService } from '@se-po/shared-data-access-services'
import { ContactInfoComponent } from '@se-po/shared-ui-contact-info'
import { forkJoin } from 'rxjs'
import { UserServiceResources as us } from 'se-resource-types'
import { ParentGuardianInfoForm } from './parent-guardian-info-form-service'
import { ParentGuardianInfoSubmitter } from './parent-guardian-info-submit.service'

@Component({
  selector: 'se-po-household-setup-feature-parent-guardian-info',
  templateUrl: './parent-guardian-info.component.html',
  styleUrls: ['./parent-guardian-info.component.scss'],
})
export class ParentGuardianInfoComponent implements OnInit {
  @ViewChild('contactInfo') public contactInfo: ContactInfoComponent
  @ViewChild('emailMatchForm') public emailMatchForm: HTMLFormElement

  public ready = false
  public actionUrl: string
  public csrfToken: string
  private readonly app = 'SingleSignOn'
  private readonly page = 'HouseholdSetup'
  private readonly label = 'ParentInfo'
  private email: string

  constructor(
    private analyticsService: AnalyticsService,
    private authSession: AuthSessionService,
    private domainEnv: SeFeDomainEnvironmentService,
    public formService: ParentGuardianInfoForm,
    private inviteService: InviteService,
    private route: ActivatedRoute,
    public setupBarService: SetupBarService,
    public store: StoreService,
    public submitter: ParentGuardianInfoSubmitter,
    private csrfTokenService: UserServiceCsrfTokenService
  ) { }

  public get form(): UntypedFormGroup {
    return this.formService.form
  }

  public ngOnInit(): void {
    this.formService.createForm()
    this.actionUrl = `${this.domainEnv.getUrl('userService')}users/sign_in`
    this.setupBarService.percentComplete = 50
    this.analyticsService.pageView(this.app, this.page, this.label)

    forkJoin({
      auth_session: this.authSession.find(),
      csrf_token: this.csrfTokenService.fetchCsrfToken()
    }).subscribe( ({ auth_session, csrf_token }) => {
      this.csrfToken = csrf_token.csrf_token
      this.initAuthSession(auth_session)
      if (auth_session.invite_token) return this.lookupInvite(auth_session.invite_token)
      this.setReady()
    })
  }

  public onContactInfoFormInit(contactInfo: ContactInfoComponent): void {
    if (this.email) contactInfo.form.patchValue({ email: this.email })
    if (this.store.disableEmail) contactInfo.form.get('email').disable()
  }

  public emailMatchSignIn(): void {
    this.submitter.submitting = true
    this.submitter.emailMatchSignIn(this.emailMatchForm)
  }

  private initAuthSession(auth_session: us.AuthSession): void {
    this.store.authSession = auth_session
    const email = this.store.authSessionEmailAddress
    if (email) this.email = email
    else {
      this.route.queryParams.subscribe(p => {
        if (p.email) this.email = p.email
      }
    )}
  }

  private lookupInvite(token: string): void {
    this.inviteService.find(token)
      .subscribe({
        next: (result) => {
          this.store.invite = result
          this.setReady()
        },
        error: () => {
          // error finding invite, ignore and move on
          this.setReady()
        }
      })
  }

  private setReady(): void {
    this.ready = true
  }
}
